import { Box, Divider, IconButton, Modal, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';

import { Form } from './Form';

interface CreateClientModalProps {
  open: boolean;
  onClose: () => void;
}

export const CreateClientModal = ({ open, onClose }: CreateClientModalProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('clients.create.title')}>
      <Box
        display="flex"
        flexDirection="column"
        gap={theme.spacing(2)}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: theme.spacing(3),
          borderRadius: theme.spacing(2),
        }}
      >
        <Box display="flex" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <PersonIcon color="disabled" />
            <Typography id="create-client-modal-title" variant="h6" component="h2">
              {t('clients.create.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        <Form onClose={onClose} />
      </Box>
    </Modal>
  );
};
